import request from '@/utils/request'

export function getv20a3000(param) {
    let data = param
    return request({
      url: `/v20/getv20a3000`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }
 

  export function getv20a3000ShipNo() {
    let data = ""
    return request({
      url: `/v20/getv20a3000ShipNo`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  export function getv20a3000ShipNoNew() {
    let data = ""
    return request({
      url: `/v20/getv20a3000ShipNoNew`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  export function getv20a3000TransCd() {
    let data = ""
    return request({
      url: `/v20/getv20a3000TransCd`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  export function getv20a3000Reason() {
    let data = ""
    return request({
      url: `/v20/getv20a3000Reason`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  // setSubmit1020Det
export function v20a3000confMoving(param) {
  let data = param
  return request({
    url: `/v20/v20a3000confMoving`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


 // getNormalDay
 export function getNormalDay(param) {
  let data = param
  return request({
    url: `/v20/getNormalDay`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function insertMovingReq(param) {
  let data = param  
  return request({
      url:  `/v20/insertMovingReq`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  })
}
